export default {
  createANewConsumable: "Crear un nuevo elemento consumible",
  equipmentTag: "Identificador del Equipo",
  createdBy: "Creado por",
  name: "Nombre",
  initialDate: "Fecha de inicio",
  lifetime: "Tiempo de vida",
  alertTime: "Tiempo de alerta",
  alertMessage: "El tiempo de alerta tiene que ser menor que el tiempo de vida",
  greaterThanZero: "Este campo debe ser mayor a 0.",
  mandatoryField: "Este campo es obligatorio.",
  submit: "Crear",
  year: "Año",
  month: "Mes",
  week: "Semana",
  day: "Día"
};
